module.exports = "<div class=\"itpx-heading\">\n    <h2 class=\"header\">\n        <ng-content select=[itpx-header]></ng-content>\n    </h2>\n    <ng-content select=[itpx-guidance]></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-heading/happy-heading.component.html
// module id = 960
// module chunks = 0